/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_GroupInputs */

const en_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked Group`)
};

const fr_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe lié`)
};

const de_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfte Gruppe`)
};

const it_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo collegato`)
};

const ru_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связанная группа`)
};

const es_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo vinculado`)
};

const zh_cn2_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接组`)
};

const ja_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクグループ`)
};

const hi_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक्ड ग्रुप`)
};

const pt_pt2_linked_group = /** @type {(inputs: Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo Vinculado`)
};

/**
* | output |
* | --- |
* | "Linked Group" |
*
* @param {Linked_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const linked_group = /** @type {((inputs?: Linked_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_linked_group(inputs)
	if (locale === "de") return de_linked_group(inputs)
	if (locale === "it") return it_linked_group(inputs)
	if (locale === "ru") return ru_linked_group(inputs)
	if (locale === "es") return es_linked_group(inputs)
	if (locale === "zh-CN") return zh_cn2_linked_group(inputs)
	if (locale === "ja") return ja_linked_group(inputs)
	if (locale === "hi") return hi_linked_group(inputs)
	if (locale === "pt-PT") return pt_pt2_linked_group(inputs)
	return en_linked_group(inputs)
});